import { OPEN_NOTIFICATION, HIDE_NOTIFICATION } from 'constants/notification';

export const openNotification = message => ({
  type: OPEN_NOTIFICATION,
  message: {
    type: message.type,
    text: message.text,
    timer: message.timer,
  },
});

export const hideNotification = () => ({
  type: HIDE_NOTIFICATION,
});
